// Module-level store so Footer's floating button knows
// which product the visitor is currently viewing.
// ProductDetail sets this on mount and clears it on unmount.

let _product = null;

export const setCurrentProduct = (product) => { _product = product; };
export const getCurrentProduct = () => _product;
